import { addressWrapper } from "../Functions";

export class ManualMarker {
  constructor(map, infoWindow) {
    this.map = map;
    this.infoWindow = infoWindow;
  }

  createControl(fillInFormCallback, formPrefix) {
    this.map.addListener("click", async (mapsMouseEvent) => {
      this.infoWindow.close();
      // eslint-disable-next-line no-undef
      new google.maps.Geocoder()
        .geocode({ location: mapsMouseEvent.latLng })
        .then((response) => {
          this.infoWindow.setPosition(mapsMouseEvent.latLng);
          if (this.map.getZoom() < 11) {
            this.map.setZoom(11);
            this.map.setCenter(mapsMouseEvent.latLng);
          }
          let place = response.results.find((r) => r.types.includes("street_address"));
          if (!place) {
            place = response.results.find((r) => r.types.includes("route"));
          }
          if (!place) {
            place = response.results[0];
          }
          if (place) {
            this.infoWindow.setContent(addressWrapper(place.formatted_address, fillInFormCallback, place, formPrefix));
            this.infoWindow.open(this.map);
            return place;
          } else {
            this.infoWindow.setContent("Nothing found here.");
            this.infoWindow.open(this.map);
          }
        })
        .catch((e) => window.alert("Geocoder failed due to: " + e));
    });
  }
}
